<section class="bmc-retries-uipath__title bz-dsh__header bz-space--inset-squish-m">
    <h4 class="bz-dsh__title bz-dsh__title--bold">{{ 'RPA_BOTS.RETRIES_UIPATH' | translate }}</h4>
</section>
<bzg-tab-set (onSelectTab)="onTabEvent($event)">
    <bzg-tab-item [displayName]="'Jobs'">
        <div>
            <biz-uipath-job-retries (retryJob)="retryJob($event)" (resetJob)="resetJobRetry()"></biz-uipath-job-retries>
        </div>
    </bzg-tab-item>
    <bzg-tab-item [displayName]="'Queueitems'">
        <div>
            <biz-uipath-queueitem-retries (retryQueueitem)="retryQueueitem($event)" (resetQueueitem)="resetQueueitemRetry()"></biz-uipath-queueitem-retries>
        </div>
    </bzg-tab-item>
</bzg-tab-set>